//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
let d=[[[0,"AddForeshorteningSymbol",1,0],[0,"BreakGap",1,0],[0,"BreakLineAmplitude",1,0],[1,"BreakLineColorWidth",0,"LineColorFontWidthBuilder",0],[0,"BreakLineExtension",1,0],[0,"BreakLineStyle",1,0],[0,"PropagateViewBreak",1,0],[0,"ShowBreakLines",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewBreakBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewBreakBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewBreakBuilder.Viewbreaklinestyle = Object.freeze({
    "Simple" : "Simple", "Straight" : "Straight", "Sawtooth" : "Sawtooth", "LongBreak" : "LongBreak", "Tubular" : "Tubular", "SolidTubular" : "SolidTubular", "SolidRod" : "SolidRod", "Jigsaw" : "Jigsaw", "Wood" : "Wood", "CopyCurve" : "CopyCurve", "TemplateCurve" : "TemplateCurve"});

export default SPLM;